import React from 'react';
import ExtendSearchBase from './ExtendSearchBase';
import { Checkbox } from '../../Controls';
import { getAgencies } from '../../../utils/dictionaries';

class SaleGarages extends ExtendSearchBase {
  constructor (props) {
    super(props);
    this.displayName = 'saleGarages';
    this.agenciesList = getAgencies(props.agenciesList, this.displayName);
  }

  renderPanel () {
    return (<div>
      <div className='filter-section__container'>
        <h3 className='title'>Параметры гаража</h3>

        <div className='container__row'>
          <div className='container__column'>
            {this.renderInputGroup('Площадь, м²', null, [
              {name: 'squareTotalMin', placeholder: 'От', handler: this.getHandlerFloat('squareTotalMin', 7)},
              {name: 'squareTotalMax', placeholder: 'До', handler: this.getHandlerFloat('squareTotalMax', 7)}
            ])}
          </div>
          <div className='container__column_extra-width'>
            {this.renderControlGroup('Дополнительно', (
              <div>
                <Checkbox
                  label='Охрана'
                  checked={this.getFilter('hasSecurityProtection')}
                  onUpdate={(_, state) => this.setFilter('hasSecurityProtection', state ? 1 : null)}
                />
                <Checkbox
                  label='Смотровая яма'
                  checked={this.getFilter('hasRepairPit')}
                  onUpdate={(_, state) => this.setFilter('hasRepairPit', state ? 1 : null)}
                />
                <Checkbox
                  label='Погреб'
                  checked={this.getFilter('hasCellar')}
                  onUpdate={(_, state) => this.setFilter('hasCellar', state ? 1 : null)}
                />
                <Checkbox
                  label='Электроснабжение'
                  checked={this.getFilter('hasElectricity')}
                  onUpdate={(_, state) => this.setFilter('hasElectricity', state ? 1 : null)}
                />
                <Checkbox
                  label='Отопление'
                  checked={this.getFilter('hasHeating')}
                  onUpdate={(_, state) => this.setFilter('hasHeating', state ? 1 : null)}
                />
                <Checkbox
                  label='Водоснабжение'
                  checked={this.getFilter('hasWater')}
                  onUpdate={(_, state) => this.setFilter('hasWater', state ? 1 : null)}
                />
                <Checkbox
                  label='Канализация'
                  checked={this.getFilter('hasCanalization')}
                  onUpdate={(_, state) => this.setFilter('hasCanalization', state ? 1 : null)}
                />
              </div>
            ))}
          </div>
          <div className='container__column_extra-slim'>
          </div>
        </div>
      </div>

      <div className='filter-section__container'>
        <h3 className='title'>Прочие параметры</h3>

          <div className='container__row'>
            <div className='container__column'>
              {this.renderMultiSelect('Агентство / застройщик', 'agencyId', this.agenciesList, true, 'Неважно', true)}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Поиск в описании', null, [
                {name: 'description', placeholder: 'Ключевые слова', handler: this.getHandlerString('description')}
              ])}
              {this.renderInputGroup('Контактный телефон', null, [
                {name: 'contactPhone', placeholder: '123 456 78 90', handler: this.getHandlerInt('contactPhone')}
              ])}
            </div>
            <div className='container__column'>
              {this.renderInputGroup('Номер объявления', null, [
                {name: 'id', placeholder: '12345678', handler: this.getHandlerInt('id')}
              ])}
              {this.renderControlGroup('Дополнительно', (
                <div>
                  <Checkbox
                    label='Частные объявления'
                    checked={this.getFilter('onlyOwners')}
                    onUpdate={(_, state) => this.setFilter('onlyOwners', state ? 1 : null)}
                  />
                  <Checkbox
                    label='С фото'
                    checked={this.getFilter('hasPhoto')}
                    onUpdate={(_, state) => this.setFilter('hasPhoto', state ? 1 : null)}
                  />
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>);
  }
}

export default SaleGarages;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/SaleGarages.jsx